module.exports = __webpack_public_path__ + "img/top.432dd52.png";